import { Box, Typography } from '@mui/material'
import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'
import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Note(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const note = extOrder.orderStep.trackingData?.pods?.note

  if (!note || note.uuid === 'EMPTY_NOTE_UUID') {
    return (
      <preview.Field label={texts.note.label} testId="execution-delivery-note">
        <preview.NullValue />
      </preview.Field>
    )
  }

  const { sec, text } = note
  const time = <ConvertTime seconds={sec} showSeconds={false} />

  return (
    <preview.Field label={texts.note.label} testId="execution-delivery-note">
      <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', mb: 1 }}>
        {text || <preview.NullValue />}
      </Box>
      <Typography variant="caption">
        {texts.deliveryNote.label} • {time}
      </Typography>
    </preview.Field>
  )
}
